import React, { useContext, useEffect, useState } from 'react';
import { GlobalContext } from 'providers/GlobalProvider';
import { Redirect } from 'react-router-dom';
import ContentLayout from 'components/Common/ContentLayout';
import { Grid, Tab, AppBar, Tabs } from '@mui/material';
import TabPanel from 'components/Common/TabPanel';
import GroupAPI from '../../api/GroupAPI';
import { useSnackbar } from 'notistack';
import { IKeycloakTeam } from './TeamAccess';
import EditAccess from 'components/SuperAdmin/EditAccess';
import JoinTeam from 'components/SuperAdmin/JoinTeam';

const a11yProps = (index: number) => {
  return {
    'id': `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
};

export const TeamSelectView = (props: any) => {
  const { cur_user } = useContext(GlobalContext);
  const [ value, setValue ] = useState<number>(0);
  const [ curTeam, setCurTeam ] = useState<IKeycloakTeam>({
    id: '',
    name: '',
    path: '',
    subGroups: [],
    realmRoles: []
  });
  const { enqueueSnackbar } = useSnackbar();

  const handleChange = (event: any, newValue: number) => {
    setValue(newValue);
  };

  const addClass = () => {
    document.getElementById('ThemeTabs')?.classList.toggle('TabItem-3');
  };

  if (cur_user.bite_super_admin === false) {
    return <Redirect to='/' />;
  }

  useEffect(() => {
    const group_id = props.match.params.id;
    GroupAPI.getGroupById(group_id)?.then((res) => {
      if (res?.success) {
        setCurTeam(res.result);
      }else{
        const err_text = `Error loading team: ${res?.result}`;
        enqueueSnackbar(err_text, { variant: 'error' });
      }
    });
  }, []);

  return (
    <ContentLayout title={curTeam?.name}>
      <Grid item xs={12}>
        <AppBar position='static' className='Tab-Appbar'>
          <Tabs
            className='ThemeTabs'
            id='ThemeTabs'
            value={value}
            onChange={handleChange}
            aria-label=''
          >
            <Tab onClick={addClass} label='Edit Access' {...a11yProps(0)} />
            <Tab onClick={addClass} label='Join Team' {...a11yProps(1)} />
          </Tabs>
        </AppBar>

        <TabPanel value={value} index={0} className='Tab-Body'>
          <Grid container>
            <Grid item xs={12} lg={6} md={6} sm={6}>
              <EditAccess curTeam={curTeam} />
            </Grid>
          </Grid>
        </TabPanel>

        <TabPanel value={value} index={1} className='Tab-Body'>
          <Grid container>
            <Grid item xs={12} lg={6} md={6} sm={6}>
              <JoinTeam curUser={cur_user} curTeam={curTeam} />
            </Grid>
          </Grid>
        </TabPanel>
      </Grid>
    </ContentLayout>
  );
};

export default TeamSelectView;
